import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dhats-form-fields-group',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="space-y-4 p-4 rounded-xl border" [style.border-color]="'var(--glass-border)'" [style.background]="stained ? 'var(--stained-glass-bg)' : 'var(--glass-bg)'">
      @if (title) {
        <div class="pb-1 border-b" style="border-color: var(--glass-border)">
          <span class="block text-[10px] font-black uppercase tracking-[0.2em]" style="color: var(--brand-color)">
            {{ title }}
          </span>
        </div>
      }
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class FormFieldsGroupComponent {
  @Input() title?: string;
  @Input() stained?: boolean;
}
